import { __decorate } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { getStaFeeTrailPage } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
let PiPileRateChangeRecord = class PiPileRateChangeRecord extends mixins(tableMaxHeight) {
    constructor() {
        super(...arguments);
        this.formInline = {
            globalPageIndex: 1,
            globalPageSize: 10,
            staPkId: "",
            globalOrder: "",
        };
        this.loading = false;
        this.total = 0;
        this.tableList = [];
        this.tableColumns = [
            {
                title: i18n.t("pileInfoDetail.oldFeeName"),
                key: "oldFeeName",
                minWidth: 110,
            },
            {
                title: i18n.t("pileInfoDetail.newFeeName"),
                key: "newFeeName",
                minWidth: 130,
            },
            {
                title: i18n.t("pileInfoDetail.replaceTime"),
                key: "replaceTime",
                minWidth: 100,
            },
        ];
    }
    tableChange(val) {
        this.formInline.globalPageIndex = val;
        this.getTableList();
    }
    tableSizeChange(val) {
        this.formInline.globalPageSize = val;
        this.getTableList();
    }
    formDataNull(data) {
        const json = {};
        for (const i in data) {
            if (data[i] !== "" && data[i] !== undefined) {
                json[i] = data[i];
            }
        }
        return json;
    }
    async getTableList() {
        this.loading = true;
        this.formInline.staPkId = this.staPkId;
        const params = this.$common.forNull(this.formInline);
        const ret = await getStaFeeTrailPage(params);
        if (ret.status == this["$config"].apiStatus) {
            this.tableList = ret.data;
            this.total = ret.total;
        }
        this.loading = false;
    }
    onClickSearch() {
        this.formInline.globalPageIndex = 1;
        this.getTableList();
    }
    mounted() {
        this.getTableList();
    }
};
__decorate([
    Prop({ default: "" })
], PiPileRateChangeRecord.prototype, "staPkId", void 0);
PiPileRateChangeRecord = __decorate([
    Component({
        components: {},
    })
], PiPileRateChangeRecord);
export default PiPileRateChangeRecord;
